import { SupplierTypeEnum } from "@gtpl/shared-models/common-models";

export class SupplierTypeRequest {
    supplierType: SupplierTypeEnum;
    constructor(supplierType:SupplierTypeEnum){
        this.supplierType = supplierType;
    }
}